module.exports = __webpack_public_path__ + "static/media/cover-fallback.d24fb504.webp";